
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make-your-paystub",
      function () {
        return require("private-next-pages/make-your-paystub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make-your-paystub"])
      });
    }
  